'use client';

import React__default from 'react';

var ArrowRightIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d, _e = _a.color, color = _e === void 0 ? '#005aff' : _e;
    return (React__default.createElement("svg", { width: width, height: height, viewBox: '0 0 20 20', onClick: function () { return onClick && onClick(); } },
        React__default.createElement("g", { id: 'icons/nav/icon-arrow-right/size-xs', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round' },
            React__default.createElement("polyline", { id: 'Stroke-718', stroke: color, strokeWidth: '1.5', transform: 'translate(10.000000, 10.000000) scale(-1, 1) rotate(180.000000) translate(-10.000000, -10.000000) ', points: '7 4 13 10 7 16' }))));
};
var index = /*#__PURE__*/ React__default.memo(ArrowRightIcon);

export { index as default };
//# sourceMappingURL=index.js.map
